import React from "react";

import { colors, menuOffset } from "../../theme";
import { Offer, OfferTitle, OfferButton, More } from "./supportTheme";

function SupportDonationOffer() {
  return (
    <Offer>
      <OfferTitle color={colors.purple}>Faire un don</OfferTitle>
      <h3>Don libre</h3>
      <OfferButton as="a" href="https://dons.lemediatv.fr">
        Je fais un don
      </OfferButton>
      <ul>
        <li>
          <i className="fa-fw fas fa-check" /> Soutenez financièrement Le Média
        </li>
      </ul>
      <div>
        <strong>-66%</strong> déduits des impôts dans la limite de 20% du revenu
        imposable
      </div>
      <More
        to="DON"
        offset={-Math.abs(parseInt(menuOffset, 10) + 10)}
        isDynamic
        smooth
        duration={400}
      >
        En savoir plus
      </More>
    </Offer>
  );
}

export default SupportDonationOffer;
